import type { ContentItemModel, CreatorModel } from '@domain/models';
import type { PuzzleDBO } from '@infrastructure/firebase/firestore/dto/PuzzleDBO';
import type { AuthorDBO } from '@infrastructure/firebase/firestore/dto/AuthorDBO';

export abstract class FirestorePuzzleRepository {
	protected puzzleDBOToContentItem(id: string, puzzleDBO: PuzzleDBO): ContentItemModel {
		return {
			id: id,
			type: puzzleDBO.type,
			authorId: puzzleDBO.Publisher,
			name: puzzleDBO.name,
			imageSrc: puzzleDBO.videoIconUrl || puzzleDBO.iconURL,
			// Full-resolution source for detail pages. `iconURL`/`videoIconUrl` are small
			// (256px) thumbnails. For static puzzles `url` holds the original image; for
			// video puzzles `url` is the mp4, so use `videoPreviewPlaceholderUrl` — the
			// full-frame video poster — instead of upscaling the 256px icon.
			imageSrcFull:
				puzzleDBO.type === 'video'
					? puzzleDBO.videoPreviewPlaceholderUrl || puzzleDBO.videoIconUrl || puzzleDBO.iconURL
					: puzzleDBO.url || puzzleDBO.iconURL,
			keywords: puzzleDBO.keywords ? puzzleDBO.keywords.split(' ') : [],
			createdAt: puzzleDBO.createdAt.toDate(),
			publishedAt: puzzleDBO.publishedAt ? puzzleDBO.publishedAt.toDate() : null,
			imageSrcLowQuality:
				puzzleDBO.lowQualityImageUrl ||
				puzzleDBO.videoPreviewPlaceholderUrl ||
				puzzleDBO.videoPreviewUrl ||
				puzzleDBO.url,
			// Prefer the full-length video so it loops over its entire duration; the
			// `videoPreviewUrl` is only a short preview clip.
			videoPreview: puzzleDBO.url || puzzleDBO.videoPreviewUrl,
			likes: puzzleDBO.likes,
			plays: puzzleDBO.plays,
			isAI: puzzleDBO.aiGenerated || false,
			collectionsIds: puzzleDBO.collections || [],
		};
	}

	protected creatorDBOToCreatorModel(id: string, creatorDBO: AuthorDBO): CreatorModel {
		return {
			id: id,
			name: creatorDBO?.username || '',
			avatarSrc: creatorDBO?.profileImageUrl,
			profileLink: creatorDBO?.profileLink,
			coverImageUrl: creatorDBO?.coverImageUrl,
			puzzlesCount: creatorDBO?.Puzzles,
			followersCount: creatorDBO?.Followers,
			followingCount: creatorDBO?.Following,
			status: creatorDBO?.status,
			country: creatorDBO?.Country,
			createdAt: creatorDBO?.createdAt ? creatorDBO?.createdAt.toDate() : null,
		};
	}
}
